// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container principal avec marge pour la sidebar - Cohérence avec les autres interfaces */
.facture-page {
  /* margin-left: 230px; */
  padding: 2rem;
  min-height: 100vh;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 25%, #f5f7fa 50%, #c3cfe2 100%);
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.facture-page h1 {
  color: #1e293b;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #3b82f6 0%, #4f46e5 25%, #7c3aed 50%, #8b5cf6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

/* Ligne de filtres */
.facture-filters-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  align-items: center;
  background: rgba(255, 255, 255, 0.9);
  padding: 1.5rem;
  border-radius: 16px;
  backdrop-filter: blur(10px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.1);
}

/* Responsive table wrapper */
.table-responsive {
  overflow-x: auto;
  margin-bottom: 2rem;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  background: white;
}

/* Mobile responsive behavior */
@media (max-width: 768px) {
  .table-responsive {
    border-radius: 8px;
  }
  
  .factures-table {
    min-width: 1000px; /* Minimum width to maintain readability */
  }
  
  .facture-filters-row {
    flex-direction: column;
    align-items: stretch;
  }
  
  .facture-filters-row select,
  .facture-filters-row input {
    width: 100%;
    min-width: auto;
  }
  
  .facture-page {
    padding: 1rem;
  }
  
  .facture-page h1 {
    font-size: 2rem;
  }
}

/* Status badge styles */
.status-badge {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid;
  -webkit-user-select: none;
          user-select: none;
}

.status-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* Disabled status badge (for paid invoices) */
.status-badge[style*="cursor: not-allowed"] {
  cursor: not-allowed !important;
  opacity: 0.8;
}

.status-badge[style*="cursor: not-allowed"]:hover {
  transform: none;
  box-shadow: none;
  background-color: #d4edda !important;
  border-color: #c3e6cb !important;
}

.status-paid {
  background-color: #d4edda;
  color: #155724;
  border-color: #c3e6cb;
}

.status-paid:hover {
  background-color: #c3e6cb;
  border-color: #b8dabd;
}

.status-unpaid {
  background-color: #f8d7da;
  color: #721c24;
  border-color: #f5c6cb;
}

.status-unpaid:hover {
  background-color: #f5c6cb;
  border-color: #f1b0b7;
}

.facture-filters-row input,
.facture-filters-row select {
  padding: 0.875rem 1.25rem;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 0.875rem;
  background: white;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  min-width: 200px;
  flex: 1 1;
}

.facture-filters-row input:focus,
.facture-filters-row select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  transform: translateY(-1px);
}

.facture-filters-row input::placeholder {
  color: #94a3b8;
  font-style: italic;
}

/* Tableau principal des factures */
.factures-table {
  width: 100%;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  border-collapse: collapse;
  margin-bottom: 2rem;
}

.factures-table thead {
  background: linear-gradient(135deg, #3b82f6 0%, #4f46e5 25%, #7c3aed 50%, #8b5cf6 100%);
}

.factures-table thead th {
  padding: 1rem 0.75rem;
  text-align: left;
  font-weight: 600;
  color: white;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
}

.factures-table tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: all 0.2s ease;
}

.factures-table tbody tr:hover {
  background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%);
  transform: scale(1.002);
}

.factures-table tbody tr:last-child {
  border-bottom: none;
}

.factures-table tbody td {
  padding: 0.875rem 0.75rem;
  color: #374151;
  font-size: 0.8rem;
  vertical-align: middle;
  white-space: nowrap;
}

/* Styles spéciaux pour certaines colonnes */
.factures-table tbody td:nth-child(1) {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-weight: 600;
  color: #4f46e5;
}

/* Client column styling - smaller and compact */
.factures-table tbody td:nth-child(2) {
  width: 90px;
  min-width: 90px;
  font-size: 0.75em;
  padding: 2px 4px;
  word-break: break-word;
}

.factures-table thead th:nth-child(2) {
  width: 90px;
  min-width: 90px;
}

.factures-table tbody td:nth-child(6),
.factures-table tbody td:nth-child(7) {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-weight: 600;
  text-align: right;
}

.factures-table tbody td:nth-child(7) {
  color: #10b981;
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(5, 150, 105, 0.05));
  border-radius: 4px;
}

/* Badges de statut */
.badge {
  padding: 0.375rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: inline-block;
  transition: all 0.2s ease;
    box-sizing: border-box;

}

.badge.payée {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
}

.badge.impayée {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);
}

/* Boutons d'action dans le tableau */
.factures-table tbody td button {
  background: none;
  border: none;
  padding: 0.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #6b7280;
  margin: 0 0.25rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.factures-table tbody td button:hover {
  transform: scale(1.1);
}

.factures-table tbody td button:first-child:hover {
  background: #dbeafe;
  color: #3b82f6;
}

.factures-table tbody td button:nth-child(2):hover {
  background: #f3e8ff;
  color: #7c3aed;
}

.factures-table tbody td button:last-child:hover {
  background: #d1fae5;
  color: #10b981;
}

/* Modal overlay */
.facture-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
  animation: facture-modal-fade-in 0.3s ease;
}

@keyframes facture-modal-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Modal content */
.facture-modal-content {
  background: white;
  border-radius: 20px;
  padding: 2rem;
  max-width: 900px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  animation: facture-modal-slide-up 0.3s ease;
}

@keyframes facture-modal-slide-up {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.facture-modal-content h2 {
  color: #1e293b;
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  text-align: center;
  background: linear-gradient(135deg, #3b82f6 0%, #4f46e5 50%, #7c3aed 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Tableau dans la modal */
.facture-modal-content table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1rem;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.facture-modal-content table thead {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.facture-modal-content table thead th {
  padding: 0.875rem;
  text-align: left;
  font-weight: 600;
  color: #374151;
  font-size: 0.875rem;
  border-bottom: 2px solid #e5e7eb;
}

.facture-modal-content table tbody td {
  padding: 0.875rem;
  color: #374151;
  font-size: 0.875rem;
  border-bottom: 1px solid #f1f5f9;
}

.facture-modal-content table tbody tr:hover {
  background: #f8fafc;
}

/* Tableau interne des tranches */
.inner-tranche-table {
  margin: 0.5rem 0;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%) !important;
  border: 2px solid #bae6fd !important;
  border-radius: 8px !important;
}

.inner-tranche-table thead {
  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%) !important;
}

.inner-tranche-table thead th {
  color: white !important;
  font-size: 0.75rem !important;
  padding: 0.5rem !important;
  border-bottom: none !important;
}

.inner-tranche-table tbody td {
  padding: 0.5rem !important;
  font-size: 0.75rem !important;
  border-bottom: 1px solid #bae6fd !important;
}

.inner-tranche-table tbody tr:last-child td {
  border-bottom: none !important;
}

.inner-tranche-table tbody td:nth-child(3),
.inner-tranche-table tbody td:nth-child(4) {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-weight: 600;
  text-align: right;
}

/* Actions de modal */
.facture-modal-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
}

.facture-modal-actions button {
  padding: 0.875rem 1.5rem;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.facture-modal-actions button:first-child {
  background: linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3);
  flex: 1 1;
}

.facture-modal-actions button:first-child:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(124, 58, 237, 0.4);
}

.facture-modal-actions button:last-child {
  background: #f3f4f6;
  color: #374151;
  flex: 1 1;
}

.facture-modal-actions button:last-child:hover {
  background: #e5e7eb;
  transform: translateY(-1px);
}

/* Responsive */
@media (max-width: 1024px) {
  .facture-page {
    margin-left: 0;
    padding: 1rem;
  }
}

@media (max-width: 768px) {
  .facture-filters-row {
    flex-direction: column;
    align-items: stretch;
    padding: 1rem;
  }

  .facture-filters-row input,
  .facture-filters-row select {
    min-width: auto;
  }

  .factures-table {
    font-size: 0.7rem;
    overflow-x: auto;
    display: block;
    white-space: nowrap;
  }

  .factures-table thead th,
  .factures-table tbody td {
    padding: 0.5rem 0.25rem;
  }

  .facture-modal-content {
    padding: 1.5rem;
    margin: 1rem;
  }

  .facture-modal-actions {
    flex-direction: column;
  }

  .inner-tranche-table {
    font-size: 0.65rem;
  }
}

@media (max-width: 480px) {
  .facture-page h1 {
    font-size: 2rem;
  }

  .factures-table {
    font-size: 0.65rem;
  }

  .badge {
    font-size: 0.625rem;
    padding: 0.25rem 0.5rem;
  }
}

/* Animations pour les interactions */
.factures-table tbody tr,
.facture-modal-actions button,
.facture-filters-row input,
.facture-filters-row select {
  will-change: transform;
}

/* Scrollbar personnalisée pour la modal */
.facture-modal-content::-webkit-scrollbar {
  width: 6px;
}

.facture-modal-content::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.facture-modal-content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.facture-modal-content::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* États de chargement */
.factures-table tbody tr.loading {
  opacity: 0.6;
  pointer-events: none;
}

/* Focus visible pour l'accessibilité */
.facture-filters-row input:focus-visible,
.facture-filters-row select:focus-visible,
.facture-modal-actions button:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

/* Effet de survol sur les badges */
.factures-table tbody tr:hover .badge.payée {
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
  transform: scale(1.05);
}

.factures-table tbody tr:hover .badge.impayée {
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4);
  transform: scale(1.05);
}

/* Style pour les références de factures */
.factures-table tbody td:nth-child(1)::before {
  content: "📄";
  margin-right: 0.5rem;
}

/* Animation des boutons d'action */
.factures-table tbody td button {
  position: relative;
  overflow: hidden;
}

.factures-table tbody td button::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: currentColor;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.3s ease, height 0.3s ease;
  opacity: 0.1;
  z-index: -1;
}

.factures-table tbody td button:hover::before {
  width: 100%;
  height: 100%;
}

/* Style pour les totaux dans les tableaux internes */
.inner-tranche-table tbody tr:last-child {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  font-weight: 700;
}

/* Indicateur de devise */
.factures-table tbody td:nth-child(6)::after {
  content: " 💰";
  font-size: 0.8em;
}

/* Style pour les dates */
.factures-table tbody td:nth-child(8) {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-size: 0.75rem;
  color: #6b7280;
}

/* Messages d'état pour les factures vides */
.factures-table tbody td[colspan] {
  text-align: center;
  color: #6b7280;
  font-style: italic;
  padding: 2rem;
  background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);
}

`, "",{"version":3,"sources":["webpack://./src/styles/Factures.css"],"names":[],"mappings":"AAAA,0FAA0F;AAC1F;EACE,wBAAwB;EACxB,aAAa;EACb,iBAAiB;EACjB,uFAAuF;EACvF,uFAAuF;AACzF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,uFAAuF;EACvF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,oCAAoC;EACpC,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB,EAAE,0CAA0C;EAC/D;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,8CAA8C;AAC9C;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,yCAAyC;EACzC,gBAAgB;EAChB,SAAO;AACT;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uFAAuF;AACzF;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,4DAA4D;EAC5D,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,wDAAwD;EACxD,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,wDAAwD;EACxD,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qFAAqF;EACrF,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;IACvB,sBAAsB;;AAE1B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,6CAA6C;AAC/C;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,wEAAwE;EACxE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,wDAAwD;EACxD,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,8CAA8C;EAC9C,SAAO;AACT;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE;IACE,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;EACf;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA,qCAAqC;AACrC;;;;EAIE,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,uCAAuC;AACvC;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,gCAAgC;EAChC,6CAA6C;EAC7C,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,qDAAqD;AACrD;EACE,6DAA6D;EAC7D,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,wDAAwD;EACxD,kBAAkB;EAClB,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,6DAA6D;AAC/D","sourcesContent":["/* Container principal avec marge pour la sidebar - Cohérence avec les autres interfaces */\n.facture-page {\n  /* margin-left: 230px; */\n  padding: 2rem;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 25%, #f5f7fa 50%, #c3cfe2 100%);\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.facture-page h1 {\n  color: #1e293b;\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 2rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  background: linear-gradient(135deg, #3b82f6 0%, #4f46e5 25%, #7c3aed 50%, #8b5cf6 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n/* Ligne de filtres */\n.facture-filters-row {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  flex-wrap: wrap;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.9);\n  padding: 1.5rem;\n  border-radius: 16px;\n  backdrop-filter: blur(10px);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(59, 130, 246, 0.1);\n}\n\n/* Responsive table wrapper */\n.table-responsive {\n  overflow-x: auto;\n  margin-bottom: 2rem;\n  border-radius: 16px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  background: white;\n}\n\n/* Mobile responsive behavior */\n@media (max-width: 768px) {\n  .table-responsive {\n    border-radius: 8px;\n  }\n  \n  .factures-table {\n    min-width: 1000px; /* Minimum width to maintain readability */\n  }\n  \n  .facture-filters-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .facture-filters-row select,\n  .facture-filters-row input {\n    width: 100%;\n    min-width: auto;\n  }\n  \n  .facture-page {\n    padding: 1rem;\n  }\n  \n  .facture-page h1 {\n    font-size: 2rem;\n  }\n}\n\n/* Status badge styles */\n.status-badge {\n  display: inline-block;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: 1px solid;\n  user-select: none;\n}\n\n.status-badge:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n/* Disabled status badge (for paid invoices) */\n.status-badge[style*=\"cursor: not-allowed\"] {\n  cursor: not-allowed !important;\n  opacity: 0.8;\n}\n\n.status-badge[style*=\"cursor: not-allowed\"]:hover {\n  transform: none;\n  box-shadow: none;\n  background-color: #d4edda !important;\n  border-color: #c3e6cb !important;\n}\n\n.status-paid {\n  background-color: #d4edda;\n  color: #155724;\n  border-color: #c3e6cb;\n}\n\n.status-paid:hover {\n  background-color: #c3e6cb;\n  border-color: #b8dabd;\n}\n\n.status-unpaid {\n  background-color: #f8d7da;\n  color: #721c24;\n  border-color: #f5c6cb;\n}\n\n.status-unpaid:hover {\n  background-color: #f5c6cb;\n  border-color: #f1b0b7;\n}\n\n.facture-filters-row input,\n.facture-filters-row select {\n  padding: 0.875rem 1.25rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 0.875rem;\n  background: white;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  min-width: 200px;\n  flex: 1;\n}\n\n.facture-filters-row input:focus,\n.facture-filters-row select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n  transform: translateY(-1px);\n}\n\n.facture-filters-row input::placeholder {\n  color: #94a3b8;\n  font-style: italic;\n}\n\n/* Tableau principal des factures */\n.factures-table {\n  width: 100%;\n  background: white;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  border-collapse: collapse;\n  margin-bottom: 2rem;\n}\n\n.factures-table thead {\n  background: linear-gradient(135deg, #3b82f6 0%, #4f46e5 25%, #7c3aed 50%, #8b5cf6 100%);\n}\n\n.factures-table thead th {\n  padding: 1rem 0.75rem;\n  text-align: left;\n  font-weight: 600;\n  color: white;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  white-space: nowrap;\n}\n\n.factures-table tbody tr {\n  border-bottom: 1px solid #f1f5f9;\n  transition: all 0.2s ease;\n}\n\n.factures-table tbody tr:hover {\n  background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%);\n  transform: scale(1.002);\n}\n\n.factures-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.factures-table tbody td {\n  padding: 0.875rem 0.75rem;\n  color: #374151;\n  font-size: 0.8rem;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n/* Styles spéciaux pour certaines colonnes */\n.factures-table tbody td:nth-child(1) {\n  font-family: \"Monaco\", \"Menlo\", \"Ubuntu Mono\", monospace;\n  font-weight: 600;\n  color: #4f46e5;\n}\n\n/* Client column styling - smaller and compact */\n.factures-table tbody td:nth-child(2) {\n  width: 90px;\n  min-width: 90px;\n  font-size: 0.75em;\n  padding: 2px 4px;\n  word-break: break-word;\n}\n\n.factures-table thead th:nth-child(2) {\n  width: 90px;\n  min-width: 90px;\n}\n\n.factures-table tbody td:nth-child(6),\n.factures-table tbody td:nth-child(7) {\n  font-family: \"Monaco\", \"Menlo\", \"Ubuntu Mono\", monospace;\n  font-weight: 600;\n  text-align: right;\n}\n\n.factures-table tbody td:nth-child(7) {\n  color: #10b981;\n  background: linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(5, 150, 105, 0.05));\n  border-radius: 4px;\n}\n\n/* Badges de statut */\n.badge {\n  padding: 0.375rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  display: inline-block;\n  transition: all 0.2s ease;\n    box-sizing: border-box;\n\n}\n\n.badge.payée {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);\n}\n\n.badge.impayée {\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: white;\n  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);\n}\n\n/* Boutons d'action dans le tableau */\n.factures-table tbody td button {\n  background: none;\n  border: none;\n  padding: 0.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #6b7280;\n  margin: 0 0.25rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.factures-table tbody td button:hover {\n  transform: scale(1.1);\n}\n\n.factures-table tbody td button:first-child:hover {\n  background: #dbeafe;\n  color: #3b82f6;\n}\n\n.factures-table tbody td button:nth-child(2):hover {\n  background: #f3e8ff;\n  color: #7c3aed;\n}\n\n.factures-table tbody td button:last-child:hover {\n  background: #d1fae5;\n  color: #10b981;\n}\n\n/* Modal overlay */\n.facture-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n  animation: facture-modal-fade-in 0.3s ease;\n}\n\n@keyframes facture-modal-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Modal content */\n.facture-modal-content {\n  background: white;\n  border-radius: 20px;\n  padding: 2rem;\n  max-width: 900px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);\n  animation: facture-modal-slide-up 0.3s ease;\n}\n\n@keyframes facture-modal-slide-up {\n  from {\n    transform: translateY(50px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.facture-modal-content h2 {\n  color: #1e293b;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 1.5rem;\n  text-align: center;\n  background: linear-gradient(135deg, #3b82f6 0%, #4f46e5 50%, #7c3aed 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Tableau dans la modal */\n.facture-modal-content table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 1rem;\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.facture-modal-content table thead {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n}\n\n.facture-modal-content table thead th {\n  padding: 0.875rem;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  font-size: 0.875rem;\n  border-bottom: 2px solid #e5e7eb;\n}\n\n.facture-modal-content table tbody td {\n  padding: 0.875rem;\n  color: #374151;\n  font-size: 0.875rem;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.facture-modal-content table tbody tr:hover {\n  background: #f8fafc;\n}\n\n/* Tableau interne des tranches */\n.inner-tranche-table {\n  margin: 0.5rem 0;\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%) !important;\n  border: 2px solid #bae6fd !important;\n  border-radius: 8px !important;\n}\n\n.inner-tranche-table thead {\n  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%) !important;\n}\n\n.inner-tranche-table thead th {\n  color: white !important;\n  font-size: 0.75rem !important;\n  padding: 0.5rem !important;\n  border-bottom: none !important;\n}\n\n.inner-tranche-table tbody td {\n  padding: 0.5rem !important;\n  font-size: 0.75rem !important;\n  border-bottom: 1px solid #bae6fd !important;\n}\n\n.inner-tranche-table tbody tr:last-child td {\n  border-bottom: none !important;\n}\n\n.inner-tranche-table tbody td:nth-child(3),\n.inner-tranche-table tbody td:nth-child(4) {\n  font-family: \"Monaco\", \"Menlo\", \"Ubuntu Mono\", monospace;\n  font-weight: 600;\n  text-align: right;\n}\n\n/* Actions de modal */\n.facture-modal-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.facture-modal-actions button {\n  padding: 0.875rem 1.5rem;\n  border-radius: 10px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.facture-modal-actions button:first-child {\n  background: linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%);\n  color: white;\n  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3);\n  flex: 1;\n}\n\n.facture-modal-actions button:first-child:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(124, 58, 237, 0.4);\n}\n\n.facture-modal-actions button:last-child {\n  background: #f3f4f6;\n  color: #374151;\n  flex: 1;\n}\n\n.facture-modal-actions button:last-child:hover {\n  background: #e5e7eb;\n  transform: translateY(-1px);\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .facture-page {\n    margin-left: 0;\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .facture-filters-row {\n    flex-direction: column;\n    align-items: stretch;\n    padding: 1rem;\n  }\n\n  .facture-filters-row input,\n  .facture-filters-row select {\n    min-width: auto;\n  }\n\n  .factures-table {\n    font-size: 0.7rem;\n    overflow-x: auto;\n    display: block;\n    white-space: nowrap;\n  }\n\n  .factures-table thead th,\n  .factures-table tbody td {\n    padding: 0.5rem 0.25rem;\n  }\n\n  .facture-modal-content {\n    padding: 1.5rem;\n    margin: 1rem;\n  }\n\n  .facture-modal-actions {\n    flex-direction: column;\n  }\n\n  .inner-tranche-table {\n    font-size: 0.65rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .facture-page h1 {\n    font-size: 2rem;\n  }\n\n  .factures-table {\n    font-size: 0.65rem;\n  }\n\n  .badge {\n    font-size: 0.625rem;\n    padding: 0.25rem 0.5rem;\n  }\n}\n\n/* Animations pour les interactions */\n.factures-table tbody tr,\n.facture-modal-actions button,\n.facture-filters-row input,\n.facture-filters-row select {\n  will-change: transform;\n}\n\n/* Scrollbar personnalisée pour la modal */\n.facture-modal-content::-webkit-scrollbar {\n  width: 6px;\n}\n\n.facture-modal-content::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 3px;\n}\n\n.facture-modal-content::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n.facture-modal-content::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* États de chargement */\n.factures-table tbody tr.loading {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n/* Focus visible pour l'accessibilité */\n.facture-filters-row input:focus-visible,\n.facture-filters-row select:focus-visible,\n.facture-modal-actions button:focus-visible {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}\n\n/* Effet de survol sur les badges */\n.factures-table tbody tr:hover .badge.payée {\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);\n  transform: scale(1.05);\n}\n\n.factures-table tbody tr:hover .badge.impayée {\n  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4);\n  transform: scale(1.05);\n}\n\n/* Style pour les références de factures */\n.factures-table tbody td:nth-child(1)::before {\n  content: \"📄\";\n  margin-right: 0.5rem;\n}\n\n/* Animation des boutons d'action */\n.factures-table tbody td button {\n  position: relative;\n  overflow: hidden;\n}\n\n.factures-table tbody td button::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  background: currentColor;\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n  transition: width 0.3s ease, height 0.3s ease;\n  opacity: 0.1;\n  z-index: -1;\n}\n\n.factures-table tbody td button:hover::before {\n  width: 100%;\n  height: 100%;\n}\n\n/* Style pour les totaux dans les tableaux internes */\n.inner-tranche-table tbody tr:last-child {\n  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);\n  font-weight: 700;\n}\n\n/* Indicateur de devise */\n.factures-table tbody td:nth-child(6)::after {\n  content: \" 💰\";\n  font-size: 0.8em;\n}\n\n/* Style pour les dates */\n.factures-table tbody td:nth-child(8) {\n  font-family: \"Monaco\", \"Menlo\", \"Ubuntu Mono\", monospace;\n  font-size: 0.75rem;\n  color: #6b7280;\n}\n\n/* Messages d'état pour les factures vides */\n.factures-table tbody td[colspan] {\n  text-align: center;\n  color: #6b7280;\n  font-style: italic;\n  padding: 2rem;\n  background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
